<template>
    <ul class="dropdown-menu">
        <li>
            <ul class="fancy_checkbox_list">
                <li>
                    <button @click="click('hide')" :class="['btn btn-sm', {'btn-primary active': status[fieldName]['hide']}, {'btn-default': !status[fieldName]['hide']}]">Hide links between {{fieldName}}</button>
                </li>
                <li class="pt2">
                    <button @click="click('hide')" :class="['btn btn-sm', {'btn-primary active': !status[fieldName]['hide']}, {'btn-default': status[fieldName]['hide']}]">Show links between {{fieldName}}</button>
                </li>
            </ul>
        </li>

        <li v-if="fieldName == 'datasets'">
            <div role="separator" class="divider"></div>
            <ul class="fancy_checkbox_list">
                <li>
                    <button @click="click('collapseDataset')" :class="['btn btn-sm', {'btn-primary active': status[fieldName]['collapseDataset']}, {'btn-default': !status[fieldName]['collapseDataset']}]">Collapse datasets</button>
                </li>
                <li class="pt2">
                    <button @click="click('collapseDataset')" :class="['btn btn-sm', {'btn-primary active': !status[fieldName]['collapseDataset']}, {'btn-default': status[fieldName]['collapseDataset']}]">Expand datasets</button>
                </li>
            </ul>
        </li>

        <li v-if="fieldName == 'distributions'">
            <div role="separator" class="divider"></div>
            <ul class="fancy_checkbox_list">
                <li>
                    <button @click="click('collapseDistribution')" :class="['btn btn-sm', {'btn-primary active': status[fieldName]['collapseDistribution']}, {'btn-default': !status[fieldName]['collapseDistribution']}]">Collapse distributions</button>
                </li>
                <li class="pt2">
                    <button @click="click('collapseDistribution')" :class="['btn btn-sm', {'btn-primary active': !status[fieldName]['collapseDistribution']}, {'btn-default': status[fieldName]['collapseDistribution']}]">Expand distributions</button>
                </li>
            </ul>
        </li>

        <li role="separator" class="divider"></li>
        <li>
            <ul class="fancy_checkbox_list">
                <li @click="click('dashed')">
                    <input type="radio" :checked="status[fieldName]['dashed']" ref="dashed-ref">
                    <label>
                        <span><i class="fas fa-horizontal-rule"></i> Dashed</span>
                    </label>
                </li>
                <li @click="click('dotted')">
                    <input type="radio" :checked="status[fieldName]['dotted']" ref="dotted-ref">
                    <label>
                        <span><i class="fas fa-horizontal-rule"></i> <i class="fas fa-horizontal-rule"></i> Dotted</span>
                    </label>
                </li>
            </ul>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        // The name of this field
        fieldName: {
            type: String,
            required: true
        },
        // The status of lines displayed for each type [dataset, distribution, path]
        status: {
            type: Object,
            required: true
        }
    },
    created() {
        // Prevent closing dropdown when click inside
        $(document).on('click', '.dropdown-menu', function (e) {
            e.stopPropagation()
        })
    },
    methods: {
        click(action) {
            this.$emit('click', this.fieldName, action)
        }
    }
}
</script>

<style scoped>
.fancy_checkbox_list {
    padding-left: 5px
}
.pt2 {
    padding-top:2px
}
</style>
